import * as React from 'react';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';
import { useAccountOrdersArDocDescription } from '../../hooks';

export const AccountsOrdersArDocDescription = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountOrdersArDocDescription();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
